import {isMobile} from '@/style/StyleHelpers';
import Fiche from '@/framework/base/classes/Fiche'
import {TreeNode} from '@/framework/base/components/TreeNode';
import TreeView from '@/framework/base/components/TreeView.vue';
import FicheContainer from '@/framework/base/components/FicheContainer.vue';
import ModuleHeader from '@/framework/base/components/ModuleHeader.vue';
import SectionContainer from "./SectionContainer.vue";
import LoaderButton from "./LoaderButton.vue";
import Button from "../classes/Button";
import User from "@/generated/classes/User";
import {defineComponent} from "vue";
import {useRouter} from "vue-router";
import type {RouteElements} from "@/framework/base/classes/Section.ts";
import Route from "@/generated/classes/Route.ts";

export default defineComponent({
    components: {
        TreeView,
        FicheContainer,
        ModuleHeader,
        SectionContainer,
        LoaderButton
    },
    data() {
        const selectProgress = undefined as boolean | undefined;
        const selectedNode = null as TreeNode | null;
        const lastSelectedFiche: Fiche[] = [];
        const lastRoutes: Route[] = [];
        const routeElement = null as RouteElements | null;

        return {
            isMobile: isMobile(),
            selectedFiche: new Fiche(),
            lastSelectedFiche,
            selectedNode,
            selectProgress,
            init: true,
            showWizard: false,
            wizardDone: false,
            lastShowSection: false,
            router: useRouter(),
            routeElement,
            lastRoute: null,
            notifRoute: new Route(),
            lastRoutes
        };
    },
    computed: {
        treeNodes(): TreeNode[] {
            const res: TreeNode[] = [];
            return res;
        },
        showFiche(): boolean {
            if (this.isMobile && !this.selectedFiche.type) {
                return false;
            }
            return true;
        },
        showTreeview(): boolean {
            if (this.isMobile && this.selectedFiche.type) {
                return false;
            }
            return true;
        },
        extraButtons(): Button[] {
            const buttons: Button[] = [];
            return buttons;
        }
    },
    methods: {
        hideWizard() {
            this.wizardDone = true;
            this.showWizard = false;
            User.acceptCgu(true);
        },
        selectNode(obj: unknown): void {
            this.selectNodeChild(this.treeNodes, obj);
        },
        setActiveNode(node: TreeNode): void {
            if (!this.selectProgress) {
                this.selectedNode = null;
            }
        },
        selectNodeChild(nodes: TreeNode[], obj: unknown) {
            nodes.forEach((node) => {
                if (node.obj == obj) {
                    this.selectedNode = node;
                    this.selectProgress = true;
                    this.setActiveNode(node);
                    this.selectProgress = false;
                    return;
                } else {
                    this.selectNodeChild(node.children, obj);
                }
            })
        },
        setFocus(): void {
            const ref = this.$refs['FICHE_CONTAINER'];
            if (ref) {
                // @ts-expect-error : generated method
                ref.$children[0].setFocus()
            }
        },
        openAll(): void {
            const ref = this.$refs['FICHE_CONTAINER'];
            if (ref) {
                // @ts-expect-error : generated method
                ref.$children[0].openAll()
            }
        },
        closeAll(): void {
            const ref = this.$refs['FICHE_CONTAINER'];
            if (ref) {
                // @ts-expect-error : generated method
                ref.$children[0].closeAll()
            }
        },
        back(): void {
            const index = this.lastSelectedFiche.findIndex(item => {
                return item.component === this.selectedFiche.component;
            });
            if (index > 0) {
                this.selectedFiche = this.lastSelectedFiche[index - 1];
                this.notifRoute = this.lastRoutes[index - 1];
                this.lastSelectedFiche.splice(index, 1);
            } else {
                this.lastSelectedFiche = [];
                this.lastRoutes = [];
                this.router.push({name: 'Dashboard'});
            }
        }
    }
})
